import React from 'react';
import { Redirect } from 'react-router-dom';
import { useMutation, useQuery } from '@apollo/client';
import SelectUserRoleModal from 'components/auth/SelectUserRoleModal';
import {
  GET_MY_ROLES_AND_CURRENT_USER_ROLE,
  GET_MY_SCOPE_TYPES,
  SELECT_USER_ROLE,
} from '../../gql/auth';
import { useLoading } from 'hooks';

const NeedSelectUserRole = ({ children }) => {
  const { data, loading } = useQuery(GET_MY_ROLES_AND_CURRENT_USER_ROLE);
  const [selectUserRole, { loading: selectLoading }] = useMutation(
    SELECT_USER_ROLE,
    {
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: GET_MY_ROLES_AND_CURRENT_USER_ROLE,
        },
        {
          query: GET_MY_SCOPE_TYPES,
        },
      ],
      onCompleted: ({ selectUserRole }) => {
        localStorage.setItem('token', selectUserRole.token);
      },
    }
  );
  useLoading(loading);
  if (loading) return <></>;

  if (data?.myCurrentUserRole === null) {
    const {
      me: { assignedRoles },
    } = data;
    if (!assignedRoles[0]) {
      return <Redirect to="/user-no-role" />;
    }

    // select assigned role 0 as role if only 1 role
    if (assignedRoles.length === 1) {
      const roleToSelect = assignedRoles[0];
      const source =
        roleToSelect.__typename === 'UserRole' ? 'USER' : 'PASS_ROLE';

      selectUserRole({
        variables: {
          input: {
            id: roleToSelect.id,
            source,
          },
        },
      });

      if (selectLoading) return <></>;
      return children;
    }

    return <SelectUserRoleModal visible={true} />;
  }

  return children;
};

export default NeedSelectUserRole;
